// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`renders correctly with props 1`] = `
<div
  className="admin-page react-admin-users-edit"
>
  <div
    className="header"
  >
    <h2>
      <span
        className="back"
        onClick={[Function]}
      >
        &lt;
      </span>
      <a
        className="back"
        href="/admin/users"
      >
        Users
      </a>
       
      /
       
      <a
        className="back"
        href="/admin/accounts/1/edit"
      >
        User
         
        /
      </a>
      First Last / 
      Edit
    </h2>
    <button
      className="button"
      disabled={false}
      onClick={[Function]}
      type="button"
    >
      Update User
    </button>
    <div
      style={
        Object {
          "position": "relative",
        }
      }
    >
      <div
        className="dropdown-container dots-dropdown "
        onClick={[Function]}
      >
        <button
          className="button"
          onClick={[Function]}
          type="button"
        >
          ...
        </button>
      </div>
    </div>
  </div>
  <div
    className="form"
  >
    <div
      className="tabs"
    >
      <button
        className="tab active"
        onClick={[Function]}
      >
        User Detail
      </button>
      <button
        className="tab "
        onClick={[Function]}
      >
        Account Detail
      </button>
      <button
        className="tab "
        onClick={[Function]}
      >
        Subscriptions History
      </button>
      <button
        className="tab "
        onClick={[Function]}
      >
        IP Addresses
      </button>
    </div>
    <div
      className="row"
    >
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            First Name
          </label>
          <input
            className="form-control"
            onChange={[Function]}
            placeholder="Type Here"
            type="text"
            value="First"
          />
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Last Name
          </label>
          <input
            className="form-control"
            onChange={[Function]}
            placeholder="Type Here"
            type="text"
            value="Last"
          />
        </div>
      </div>
    </div>
    <div
      className="row"
    >
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Email Address
          </label>
          <input
            className="form-control"
            onChange={[Function]}
            placeholder="Type Here"
            type="text"
            value="email@mail.com"
          />
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Account
          </label>
          <div
            className=" css-2b097c-container"
            onKeyDown={[Function]}
          >
            <div
              className=" css-ry7o3u-control"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <div
                className=" css-g1d714-ValueContainer"
              >
                <div
                  className=" css-1uccc91-singleValue"
                >
                  User
                </div>
                <div
                  className="css-b8ldur-Input"
                >
                  <div
                    className=""
                    style={
                      Object {
                        "display": "inline-block",
                      }
                    }
                  >
                    <input
                      aria-autocomplete="list"
                      autoCapitalize="none"
                      autoComplete="off"
                      autoCorrect="off"
                      disabled={false}
                      id="react-select-2-input"
                      onBlur={[Function]}
                      onChange={[Function]}
                      onFocus={[Function]}
                      spellCheck="false"
                      style={
                        Object {
                          "background": 0,
                          "border": 0,
                          "boxSizing": "content-box",
                          "color": "inherit",
                          "fontSize": "inherit",
                          "label": "input",
                          "opacity": 1,
                          "outline": 0,
                          "padding": 0,
                          "width": "1px",
                        }
                      }
                      tabIndex="0"
                      type="text"
                      value=""
                    />
                    <div
                      style={
                        Object {
                          "height": 0,
                          "left": 0,
                          "overflow": "scroll",
                          "position": "absolute",
                          "top": 0,
                          "visibility": "hidden",
                          "whiteSpace": "pre",
                        }
                      }
                    >
                      
                    </div>
                  </div>
                </div>
              </div>
              <div
                className=" css-1hb7zxy-IndicatorsContainer"
              >
                <span
                  className=" css-1xjgjl1-IndicatorSeparator"
                />
                <div
                  aria-hidden="true"
                  className=" css-tlfecz-indicatorContainer"
                  onMouseDown={[Function]}
                  onTouchEnd={[Function]}
                >
                  <svg
                    aria-hidden="true"
                    className="css-6q0nyr-Svg"
                    focusable="false"
                    height={20}
                    viewBox="0 0 20 20"
                    width={20}
                  >
                    <path
                      d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Subscription
          </label>
          <div
            className=" css-2b097c-container"
            onKeyDown={[Function]}
          >
            <div
              className=" css-ry7o3u-control"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <div
                className=" css-g1d714-ValueContainer"
              >
                <div
                  className=" css-1uccc91-singleValue"
                >
                  None
                </div>
                <input
                  aria-autocomplete="list"
                  className="css-62g3xt-dummyInput"
                  disabled={false}
                  id="react-select-3-input"
                  onBlur={[Function]}
                  onChange={[Function]}
                  onFocus={[Function]}
                  readOnly={true}
                  tabIndex="0"
                  value=""
                />
              </div>
              <div
                className=" css-1hb7zxy-IndicatorsContainer"
              >
                <span
                  className=" css-1xjgjl1-IndicatorSeparator"
                />
                <div
                  aria-hidden="true"
                  className=" css-tlfecz-indicatorContainer"
                  onMouseDown={[Function]}
                  onTouchEnd={[Function]}
                >
                  <svg
                    aria-hidden="true"
                    className="css-6q0nyr-Svg"
                    focusable="false"
                    height={20}
                    viewBox="0 0 20 20"
                    width={20}
                  >
                    <path
                      d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Academy Subscription
          </label>
          <div
            className=" css-2b097c-container"
            onKeyDown={[Function]}
          >
            <div
              className=" css-ry7o3u-control"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <div
                className=" css-g1d714-ValueContainer"
              >
                <div
                  className=" css-1uccc91-singleValue"
                >
                  None
                </div>
                <input
                  aria-autocomplete="list"
                  className="css-62g3xt-dummyInput"
                  disabled={false}
                  id="react-select-4-input"
                  onBlur={[Function]}
                  onChange={[Function]}
                  onFocus={[Function]}
                  readOnly={true}
                  tabIndex="0"
                  value=""
                />
              </div>
              <div
                className=" css-1hb7zxy-IndicatorsContainer"
              >
                <span
                  className=" css-1xjgjl1-IndicatorSeparator"
                />
                <div
                  aria-hidden="true"
                  className=" css-tlfecz-indicatorContainer"
                  onMouseDown={[Function]}
                  onTouchEnd={[Function]}
                >
                  <svg
                    aria-hidden="true"
                    className="css-6q0nyr-Svg"
                    focusable="false"
                    height={20}
                    viewBox="0 0 20 20"
                    width={20}
                  >
                    <path
                      d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      className="switch"
    >
      <span
        className="MuiSwitch-root WithStyles(ForwardRef(Switch))-root-1"
      >
        <span
          aria-disabled={false}
          className="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-6 MuiSwitch-switchBase WithStyles(ForwardRef(Switch))-switchBase-2 MuiSwitch-colorSecondary"
          onBlur={[Function]}
          onDragLeave={[Function]}
          onFocus={[Function]}
          onKeyDown={[Function]}
          onKeyUp={[Function]}
          onMouseDown={[Function]}
          onMouseLeave={[Function]}
          onMouseUp={[Function]}
          onTouchEnd={[Function]}
          onTouchMove={[Function]}
          onTouchStart={[Function]}
          tabIndex={null}
        >
          <span
            className="MuiIconButton-label"
          >
            <input
              checked={false}
              className="PrivateSwitchBase-input-9 MuiSwitch-input"
              onChange={[Function]}
              type="checkbox"
            />
            <span
              className="MuiSwitch-thumb WithStyles(ForwardRef(Switch))-thumb-3"
            />
          </span>
        </span>
        <span
          className="MuiSwitch-track WithStyles(ForwardRef(Switch))-track-4"
        />
      </span>
      <span>
        Disable User
      </span>
    </div>
    <table
      className="table user-dates"
    >
      <tbody>
        <tr>
          <td>
            Date Created
          </td>
          <td>
            12/12/24
          </td>
        </tr>
        <tr>
          <td>
            Last Login
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Account Type
          </td>
          <td>
            Individual
          </td>
        </tr>
        <tr>
          <td>
            Subscription Plan & Date
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Trial Type & Date
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Trial upgraded at (days)
          </td>
          <td>
            -
          </td>
        </tr>
      </tbody>
    </table>
    <div
      className="roles"
    >
      <h3>
        Roles
      </h3>
      <div
        className="row"
      >
        <div
          className="col-sm-4"
        >
          <div
            className="role"
          >
            <div
              className="role-checkbox "
            >
              <svg
                fill="currentColor"
                height="1em"
                onClick={[Function]}
                stroke="currentColor"
                strokeWidth="0"
                style={
                  Object {
                    "background": "#E5E5E8",
                    "borderRadius": 3,
                    "color": undefined,
                    "fill": "#E5E5E8",
                  }
                }
                version="1.1"
                viewBox="0 0 16 16"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z"
                />
              </svg>
            </div>
            Role_1
          </div>
        </div>
        <div
          className="col-sm-4"
        >
          <div
            className="role"
          >
            <div
              className="role-checkbox "
            >
              <svg
                fill="currentColor"
                height="1em"
                onClick={[Function]}
                stroke="currentColor"
                strokeWidth="0"
                style={
                  Object {
                    "background": "#E5E5E8",
                    "borderRadius": 3,
                    "color": undefined,
                    "fill": "#E5E5E8",
                  }
                }
                version="1.1"
                viewBox="0 0 16 16"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z"
                />
              </svg>
            </div>
            Role_2
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

exports[`renders correctly without props 1`] = `
<div
  className="admin-page react-admin-users-edit"
>
  <div
    className="header"
  >
    <h2>
      <span
        className="back"
        onClick={[Function]}
      >
        &lt;
      </span>
      <a
        className="back"
        href="/admin/users"
      >
        Users
      </a>
       
      /
       
      Add New
    </h2>
    <button
      className="button"
      disabled={true}
      onClick={[Function]}
      type="button"
    >
      Create User
    </button>
    <div
      style={
        Object {
          "position": "relative",
        }
      }
    />
  </div>
  <div
    className="form"
  >
    <div
      className="tabs"
    >
      <button
        className="tab active"
        onClick={[Function]}
      >
        User Detail
      </button>
      <button
        className="tab "
        onClick={[Function]}
      >
        Account Detail
      </button>
      <button
        className="tab "
        onClick={[Function]}
      >
        Subscriptions History
      </button>
      <button
        className="tab "
        onClick={[Function]}
      >
        IP Addresses
      </button>
    </div>
    <div
      className="row"
    >
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            First Name
          </label>
          <input
            className="form-control"
            onChange={[Function]}
            placeholder="Type Here"
            type="text"
            value=""
          />
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Last Name
          </label>
          <input
            className="form-control"
            onChange={[Function]}
            placeholder="Type Here"
            type="text"
            value=""
          />
        </div>
      </div>
    </div>
    <div
      className="row"
    >
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Email Address
          </label>
          <input
            className="form-control"
            onChange={[Function]}
            placeholder="Type Here"
            type="text"
            value=""
          />
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Account
          </label>
          <div
            className=" css-2b097c-container"
            onKeyDown={[Function]}
          >
            <div
              className=" css-ry7o3u-control"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <div
                className=" css-g1d714-ValueContainer"
              >
                <div
                  className=" css-18jp4mc-Placeholder"
                >
                  Search
                </div>
                <div
                  className="css-b8ldur-Input"
                >
                  <div
                    className=""
                    style={
                      Object {
                        "display": "inline-block",
                      }
                    }
                  >
                    <input
                      aria-autocomplete="list"
                      autoCapitalize="none"
                      autoComplete="off"
                      autoCorrect="off"
                      disabled={false}
                      id="react-select-5-input"
                      onBlur={[Function]}
                      onChange={[Function]}
                      onFocus={[Function]}
                      spellCheck="false"
                      style={
                        Object {
                          "background": 0,
                          "border": 0,
                          "boxSizing": "content-box",
                          "color": "inherit",
                          "fontSize": "inherit",
                          "label": "input",
                          "opacity": 1,
                          "outline": 0,
                          "padding": 0,
                          "width": "1px",
                        }
                      }
                      tabIndex="0"
                      type="text"
                      value=""
                    />
                    <div
                      style={
                        Object {
                          "height": 0,
                          "left": 0,
                          "overflow": "scroll",
                          "position": "absolute",
                          "top": 0,
                          "visibility": "hidden",
                          "whiteSpace": "pre",
                        }
                      }
                    >
                      
                    </div>
                  </div>
                </div>
              </div>
              <div
                className=" css-1hb7zxy-IndicatorsContainer"
              >
                <span
                  className=" css-1xjgjl1-IndicatorSeparator"
                />
                <div
                  aria-hidden="true"
                  className=" css-tlfecz-indicatorContainer"
                  onMouseDown={[Function]}
                  onTouchEnd={[Function]}
                >
                  <svg
                    aria-hidden="true"
                    className="css-6q0nyr-Svg"
                    focusable="false"
                    height={20}
                    viewBox="0 0 20 20"
                    width={20}
                  >
                    <path
                      d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Subscription
          </label>
          <div
            className=" css-2b097c-container"
            onKeyDown={[Function]}
          >
            <div
              className=" css-ry7o3u-control"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <div
                className=" css-g1d714-ValueContainer"
              >
                <div
                  className=" css-1uccc91-singleValue"
                >
                  None
                </div>
                <input
                  aria-autocomplete="list"
                  className="css-62g3xt-dummyInput"
                  disabled={false}
                  id="react-select-6-input"
                  onBlur={[Function]}
                  onChange={[Function]}
                  onFocus={[Function]}
                  readOnly={true}
                  tabIndex="0"
                  value=""
                />
              </div>
              <div
                className=" css-1hb7zxy-IndicatorsContainer"
              >
                <span
                  className=" css-1xjgjl1-IndicatorSeparator"
                />
                <div
                  aria-hidden="true"
                  className=" css-tlfecz-indicatorContainer"
                  onMouseDown={[Function]}
                  onTouchEnd={[Function]}
                >
                  <svg
                    aria-hidden="true"
                    className="css-6q0nyr-Svg"
                    focusable="false"
                    height={20}
                    viewBox="0 0 20 20"
                    width={20}
                  >
                    <path
                      d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="col-sm-6"
      >
        <div
          className="form-group"
        >
          <label>
            Academy Subscription
          </label>
          <div
            className=" css-2b097c-container"
            onKeyDown={[Function]}
          >
            <div
              className=" css-ry7o3u-control"
              onMouseDown={[Function]}
              onTouchEnd={[Function]}
            >
              <div
                className=" css-g1d714-ValueContainer"
              >
                <div
                  className=" css-1uccc91-singleValue"
                >
                  None
                </div>
                <input
                  aria-autocomplete="list"
                  className="css-62g3xt-dummyInput"
                  disabled={false}
                  id="react-select-7-input"
                  onBlur={[Function]}
                  onChange={[Function]}
                  onFocus={[Function]}
                  readOnly={true}
                  tabIndex="0"
                  value=""
                />
              </div>
              <div
                className=" css-1hb7zxy-IndicatorsContainer"
              >
                <span
                  className=" css-1xjgjl1-IndicatorSeparator"
                />
                <div
                  aria-hidden="true"
                  className=" css-tlfecz-indicatorContainer"
                  onMouseDown={[Function]}
                  onTouchEnd={[Function]}
                >
                  <svg
                    aria-hidden="true"
                    className="css-6q0nyr-Svg"
                    focusable="false"
                    height={20}
                    viewBox="0 0 20 20"
                    width={20}
                  >
                    <path
                      d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      className="switch"
    >
      <span
        className="MuiSwitch-root WithStyles(ForwardRef(Switch))-root-1"
      >
        <span
          aria-disabled={false}
          className="MuiButtonBase-root MuiIconButton-root PrivateSwitchBase-root-6 MuiSwitch-switchBase WithStyles(ForwardRef(Switch))-switchBase-2 MuiSwitch-colorSecondary"
          onBlur={[Function]}
          onDragLeave={[Function]}
          onFocus={[Function]}
          onKeyDown={[Function]}
          onKeyUp={[Function]}
          onMouseDown={[Function]}
          onMouseLeave={[Function]}
          onMouseUp={[Function]}
          onTouchEnd={[Function]}
          onTouchMove={[Function]}
          onTouchStart={[Function]}
          tabIndex={null}
        >
          <span
            className="MuiIconButton-label"
          >
            <input
              checked={false}
              className="PrivateSwitchBase-input-9 MuiSwitch-input"
              onChange={[Function]}
              type="checkbox"
            />
            <span
              className="MuiSwitch-thumb WithStyles(ForwardRef(Switch))-thumb-3"
            />
          </span>
          <span
            className="MuiTouchRipple-root"
          />
        </span>
        <span
          className="MuiSwitch-track WithStyles(ForwardRef(Switch))-track-4"
        />
      </span>
      <span>
        Disable User
      </span>
    </div>
    <table
      className="table user-dates"
    >
      <tbody>
        <tr>
          <td>
            Date Created
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Last Login
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Account Type
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Subscription Plan & Date
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Trial Type & Date
          </td>
          <td>
            N/A
          </td>
        </tr>
        <tr>
          <td>
            Trial upgraded at (days)
          </td>
          <td>
            -
          </td>
        </tr>
      </tbody>
    </table>
    <div
      className="roles"
    >
      <h3>
        Roles
      </h3>
    </div>
  </div>
</div>
`;
